// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetUserAnswersFromHistoryRequest,
  TGetUserAnswersFromHistoryModel,
  IMappers,
  TGetUserAnswersFromHistoryResponse,
  IGetUserAnswersFromHistoryResponse,
  IGetUserAnswersFromHistoryResponseError,
} from './types';

export const defaultConfig: TGetUserAnswersFromHistoryModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v2/get-user-answers-from-history/',
  requestType: 'json',
} as TGetUserAnswersFromHistoryModel;

export function createGetUserAnswersFromHistoryModel(
  parameters: IGetUserAnswersFromHistoryRequest,
): TGetUserAnswersFromHistoryModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetUserAnswersFromHistoryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetUserAnswersFromHistoryRequest;
}

export async function fetchGetUserAnswersFromHistory<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetUserAnswersFromHistoryOptions<TResponse200, TResponse400>): Promise<
  TGetUserAnswersFromHistoryResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetUserAnswersFromHistoryModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUserAnswersFromHistoryResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetUserAnswersFromHistoryResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetUserAnswersFromHistoryResponse;
}
